const NON_PASSIVE_OPTIONS = { passive: false };
const GESTURE_EVENT_LIST = ['gesturestart', 'gesturechange', 'gestureend'];
const ZOOM_KEY_LIST = ['+', '-', '=', '_', '0'];

function preventWheelZoom(event) {
  if (!event.ctrlKey) {
    return;
  }

  event.preventDefault();
}

function preventGestureZoom(event) {
  event.preventDefault();
}

function preventKeyboardZoom(event) {
  if (!event.ctrlKey && !event.metaKey) {
    return;
  }

  if (!ZOOM_KEY_LIST.includes(event.key)) {
    return;
  }

  event.preventDefault();
}

export function initZoomLock() {
  document.addEventListener('wheel', preventWheelZoom, NON_PASSIVE_OPTIONS);
  document.addEventListener('keydown', preventKeyboardZoom);

  GESTURE_EVENT_LIST.forEach((eventName) => {
    document.addEventListener(eventName, preventGestureZoom, NON_PASSIVE_OPTIONS);
  });
}
